export default class {
    constructor(){
        this.chat = null;
    }
    sendMessage(text){
        if(this.chat) this.chat.sendOnlyText(text);
    }
  
    subscribeChat(chat) {
      this.chat = chat;
    }
}
  